// @flow

import xDayTypeOverZSpellInYPeriodType from "./x-day-type-over-z-spell-in-y-period-type";
import xDayTypeInYPeriodType from "./x-day-type-in-y-period-type";
import hoursLostOverAvgWchInYPeriodOverZPeriodType from "./hours-lost-over-avg-wch-in-y-period-over-z-period-type";
import absenceRatePercentage from "./absence-rate-percentage";
import xHoursInYPeriodType from "./x-hours-in-y-period-type";
import xSpellsInYPeriodType from "./x-spells-in-y-period-type";
import xDayTypeOfContinuousAbsence from "./x-day-type-of-continuous-absence";
import bradfordScoreOverXInYMonths from "./bradford-score-over-x-in-y-months";
import absenceReasonAlertType from "./absence-reason-alert-type";
import xDayTypeOrZSpellsInYPeriodType from "./x-day-type-or-z-spells-in-y-period-type";
import xSpellsOfSameReasonInYPeriodType from "./x-spells-of-same-reason-in-y-period-type";
import workRelated from "./work-related";

export default {
  X_DAY_TYPE_OVER_Z_SPELLS_IN_Y_PERIOD_TYPE: xDayTypeOverZSpellInYPeriodType,
  X_DAY_TYPE_IN_Y_PERIOD_TYPE: xDayTypeInYPeriodType,
  HOURS_LOST_OVER_AVG_WCH_IN_Y_PERIOD_OVER_Z_PERIOD_TYPE: hoursLostOverAvgWchInYPeriodOverZPeriodType,
  ABSENCE_RATE_PERCENTAGE: absenceRatePercentage,
  X_HOURS_IN_Y_PERIOD_TYPE: xHoursInYPeriodType,
  X_SPELLS_IN_Y_PERIOD_TYPE: xSpellsInYPeriodType,
  X_DAY_TYPE_OF_CONTINUOUS_ABSENCE: xDayTypeOfContinuousAbsence,
  BRADFORD_SCORE_OVER_X_IN_Y_MONTHS: bradfordScoreOverXInYMonths,
  ABSENCE_REASON_ALERT_TYPE: absenceReasonAlertType,
  X_DAY_TYPE_OR_Z_SPELLS_IN_Y_PERIOD_TYPE: xDayTypeOrZSpellsInYPeriodType,
  X_SPELLS_OF_SAME_REASON_IN_Y_PERIOD_TYPE: xSpellsOfSameReasonInYPeriodType,
  WORK_RELATED: workRelated,
};

export * from "./types";
